// todo move this file to module
export let ProfileFillRequirementOptions = {
    '1': 'فعال',
    '0': 'غیرفعال',
}